import { Typography } from '@mui/material';
import './JobDescription.scss';
import Signup from './Signup';
import Carousel from '../utils/Carousel';

function JobDescription() {
    return (
        <div className='job-description-wrp wrapper'>
            <div className='site-content'>
                <div className='title-1'>
                    Find the <span>Freelance Works</span> that You Love
                </div>
                <div className='site-sub-content'>
                    <div className='title-2'>
                        Find great works just from home and work from home
                    </div>
                    <div className='popular-categories-wrp'>
                        <div className='popular-categories-title'>Popular Categories</div>
                        <div className='popular-categories-container'>
                            <Carousel numberOfCards={4} arrows={false} cards={[
                                <Typography className='popular-category'>UI Design</Typography>,
                                <Typography className='popular-category'>Logo Design</Typography>,
                                <Typography className='popular-category'>Online Typing</Typography>,
                                <Typography className='popular-category'>Content Writing</Typography>,
                                <Typography className='popular-category'>More categories</Typography>,
                            ]}></Carousel>
                        </div>
                    </div>
                    <div className='users-count-wrp'>
                        Over <span className='user-count'>7000+</span> UsersWorking Part-time Daily
                    </div>
                </div>
            </div>
            <Signup></Signup>
        </div>
    );
}

export default JobDescription;